<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="inline">
          <input-fecha-hora
            v-model="fechaInicioLocal"
          />
        </div>
        <div class="inline">
          <input-fecha-hora
            v-model="fechaFinLocal"
            class="m-l-sm"
          />
        </div>
      </div>
    </div>
    <div class="flex-container m-t-sm">
      <div class="column">
        <div class="card">
          <div class="card-body">
            <h3 class="text-center">
              {{ $I18n.t('guardias_realizadas') }}
            </h3>
            <chart-ranking-usuarios :dataset="profesoresGuardias" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="card">
          <div class="card-body">
            <h3 class="text-center">
              {{ $I18n.t('veces_cubierto') }}
            </h3>
            <chart-ranking-usuarios :dataset="profesoresCubiertos" />
          </div>
        </div>
      </div>
    </div>
    <div class="row m-t-sm">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <h3 class="text-center">
              {{ $I18n.t('Grupos') }}
            </h3>
            <div class="row">
              <no-hay-datos v-if="!gruposGuardias.length" />
              <div class="col-md-6">
                <canvas id="grupos-barras" class="chart"></canvas>
              </div>
              <div class="col-md-6">
                <canvas id="grupos-donut" class="chart chart-donut"></canvas>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import guardias from '../../../api/cifra/guardias/guardias';
import NoHayDatos from '../../../components/cifra/charts/NoHayDatos.vue';
import ChartRankingUsuarios from '../../../components/cifra/charts/ChartRankingUsuarios.vue';
import ChartBarras, { BACKGROUND_COLORS, BORDER_COLORS } from '../../../components/cifra/charts/ChartBarras';

/* global Chart, ChartDataLabels */
export default {
  components: { ChartRankingUsuarios, NoHayDatos },
  props: {
    fechaInicio: { type: String, required: true },
    fechaFin: { type: String, required: true },
  },
  data() {
    return {
      fechaInicioLocal: this.fechaInicio,
      fechaFinLocal: this.fechaFin,
      profesoresGuardias: [],
      profesoresCubiertos: [],
      gruposGuardias: [],
      porcentajeGrupos: [],
    };
  },
  watch: {
    fechaInicioLocal() {
      this.loadData();
    },
    fechaFinLocal() {
      this.loadData();
    },
    gruposGuardias(value) {
      this.chartGrupos.setDataFromArray(value);
      this.chartGrupos.update();
      this.updateChartFromArray(this.chartDonutGrupos, value);
    },
    porcentajeGrupos(value) {
      this.updateChartFromArray(this.chartDonutGrupos, value);
    },
  },
  mounted() {
    this.loadCharts();
    this.loadData();
  },
  methods: {
    loadData() {
      guardias.infoEstadisticas(this.fechaInicioLocal, this.fechaFinLocal).then((response) => {
        this.profesoresGuardias = response.data.profesores_guardias;
        this.profesoresCubiertos = response.data.profesores_cubiertos;
        this.gruposGuardias = response.data.grupos_guardias;
        this.porcentajeGrupos = response.data.porcentaje_grupos;
      });
    },
    loadCharts() {
      this.chartGrupos = this.crearChartBarras('grupos-barras', this.gruposGuardias, false);
      this.loadChartDonutGrupos();
    },
    loadChartDonutGrupos() {
      this.chartDonutGrupos = new Chart(document.getElementById('grupos-donut'), {
        plugins: [ChartDataLabels],
        type: 'doughnut',
        data: {
          labels: [],
          datasets: [
            {
              label: this.$I18n.t('guardias'),
              data: [],
              backgroundColor: BACKGROUND_COLORS,
              borderColor: BORDER_COLORS,
              borderWidth: 1,
            },
          ],
        },
        options: {
          responsive: false,
          maintainAspectRatio: true,
          aspectRatio: 1,
          legend: { display: false },
          tooltips: {
            callbacks: {
              label(tooltipItem, data) {
                const label = data.labels[tooltipItem.index];
                const valor = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                return `${label}: ${valor}%`;
              },
            },
          },
          plugins: {
            datalabels: {
              formatter(value, _context) {
                return `${value}%`;
              },
            },
          },
        },
      });
      this.updateChartFromArray(this.chartDonutGrupos, this.porcentajeGrupos);
    },
    crearChartBarras(id, dataArray, horizontal = true) {
      const chart = new ChartBarras(
        document.getElementById(id),
        { horizontal, tooltips: false },
      );
      chart.setDataFromArray(dataArray);
      chart.start();
      return chart;
    },
    updateChartFromArray(chart, arrayData) {
      chart.data.labels = arrayData.map((dato) => dato[0]);
      chart.data.datasets[0].data = arrayData.map((dato) => dato[1]);
      chart.update();
    },
  },
};
</script>

<style lang="scss" scoped>
  .chart {
    max-width: 440px;
    max-height: 220px;
    margin: auto;
    &.chart-donut {
      max-width: 220px;
    }

    @media (min-height: 960px) {
      max-width: 600px;
      max-height: 300px;
      margin: auto;
      &.chart-donut {
        max-width: 300px;
      }
    }
  }
</style>
